import React, { Component } from 'react';

class ResetButton extends Component {
  render() {
    return (
      <p onClick={() => this.props.clickHandler()} className="resetButton">
      <img
          src="https://cdn.sandals.com/sandals/v12/images/resorts/resorts/reset-circle.svg"
          alt="Reset Button"
        />
        {' '}Reset
      </p>
    );
  }
}

export default ResetButton;